module.exports = __webpack_public_path__ + "static/media/step3.e04df7c8.png";